import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { TrimDirective } from '../../directives/trim.directive';
import { MessageModule } from 'primeng/message';
import { InputMaskModule } from 'primeng/inputmask';

@Component({
  selector: 'app-input-mask',
  imports: [CommonModule, ReactiveFormsModule, InputTextModule, TrimDirective, MessageModule, InputMaskModule ],
  templateUrl: './input-mask.component.html',
  styleUrl: './input-mask.component.scss'
})
export class InputMaskComponent {

  @Input() form!: FormGroup;
  @Input() field!: string;
  @Input() label!: string;
  @Input() placeholder!: string;
  @Input() groupName!: string;

}
